import { Box, Button, Flex, Show, Text } from "@chakra-ui/react";
import ModalDrawer from "@components/ModalDrawer";
import BaseImage from "@components/BaseImage";
import { formatEtherNumber } from "@constants/common";
import { BigNumber } from "ethers";

interface ClaimKepConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  elPoints: BigNumber;
  actionText: string;
}
const ClaimKepConfirmation = ({
  isOpen,
  onClose,
  elPoints,
  actionText,
}: ClaimKepConfirmationProps) => {
  return (
    <ModalDrawer isOpen={isOpen} closeAlert={onClose}>
      <Flex
        padding={{ base: "24px 16px", md: "40px" }}
        flexDirection="column"
        width="100%"
        gap={"32px"}
      >
        <Flex justifyContent={"space-between"} align={"center"}>
          <Text fontSize={"16px"} lineHeight={"24px"} fontWeight={"600"}>
            Claiming $KEP
          </Text>
          <Button
            variant="unstyled"
            display="flex"
            p={{ base: "1.5rem 0", md: 0 }}
            height="24px"
            onClick={onClose}
            _focus={{
              boxShadow: "none",
            }}
          >
            <Show above="md">
              <BaseImage
                height={24}
                width={24}
                alt="close"
                src="/assets/close.svg"
              />
            </Show>
            <Show below="md">
              <BaseImage
                height={4}
                width={20}
                alt="close"
                src="/assets/close_mobile.svg"
              />
            </Show>
          </Button>
        </Flex>

        <Flex
          flexDir={"column"}
          background={"#f5f5f5"}
          borderRadius={"20px"}
          p={"16px"}
          gap="16px"
        >
          <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Flex flexDir={"column"}>
              <Text
                fontSize={"14px"}
                lineHeight={"21px"}
                fontWeight={"500"}
                color="textTertiary"
              >
                You are converting
              </Text>
              <Text fontSize={"32px"} lineHeight={"48px"} fontWeight={"600"}>
                {formatEtherNumber(elPoints.toString())} EL Points
              </Text>
            </Flex>
            <Box
              lineHeight={0}
              p={"8px"}
              background={"#E0E0E0"}
              borderRadius={"100%"}
              width={"56px"}
              height={"56px"}
              pos="relative"
            >
              <BaseImage src="/assets/claim/eigen.svg" alt="eigen" fill />
            </Box>
          </Flex>

          <Box
            lineHeight={0}
            borderRadius={"100%"}
            width={"36px"}
            height={"36px"}
            pos="relative"
          >
            <BaseImage src="/assets/arrow_down.svg" alt="eigen" fill />
          </Box>

          <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Flex flexDir={"column"}>
              <Text
                fontSize={"14px"}
                lineHeight={"21px"}
                fontWeight={"500"}
                color="textTertiary"
              >
                You will get
              </Text>
              <Text fontSize={"32px"} lineHeight={"48px"} fontWeight={"600"}>
                {formatEtherNumber(elPoints.mul(995).div(1000).toString())} $KEP
              </Text>
            </Flex>
            <Box
              lineHeight={0}
              p={"8px"}
              background={"#E0E0E0"}
              borderRadius={"100%"}
              width={"56px"}
              height={"56px"}
              pos="relative"
            >
              <BaseImage src="/assets/claim/kep.svg" alt="eigen" fill />
            </Box>
          </Flex>

          <Flex
            background={"backgroundField"}
            justifyContent={"space-between"}
            p={"8px 10px"}
            fontSize={"12px"}
            lineHeight={"18px"}
            fontWeight={"400"}
          >
            <Text>Fees (0.5%)</Text>
            <Text>
              {formatEtherNumber(
                BigNumber.from(elPoints).mul(5).div(1000).toString()
              )}{" "}
              KEP
            </Text>
          </Flex>
        </Flex>

        <Flex align={"center"} justifyContent={"center"} gap={"10px"}>
          <BaseImage
            src="/assets/loader.svg"
            alt="eigen"
            height={40}
            width={40}
          />
          {actionText}
        </Flex>
      </Flex>
    </ModalDrawer>
  );
};

export default ClaimKepConfirmation;
